// extracted by mini-css-extract-plugin
export var actionButtonGroup = "Nav-module--actionButtonGroup--1qR7e";
export var darkActionButtonGroup = "Nav-module--darkActionButtonGroup--RCg4d";
export var gitHubButtonWrap = "Nav-module--gitHubButtonWrap--dxAQ2";
export var icon = "Nav-module--icon--aqt4-";
export var iconGroup = "Nav-module--iconGroup--VdZVf";
export var iconWrapper = "Nav-module--iconWrapper--80waa";
export var langSelect = "Nav-module--langSelect--q8rgO";
export var lightActionButtonWrapper = "Nav-module--lightActionButtonWrapper--N3uC7";
export var lightLangSelect = "Nav-module--lightLangSelect--TwG3j";
export var menuExpand = "Nav-module--menuExpand--j1J-R";
export var menuExpandLink = "Nav-module--menuExpandLink--cnrwb";
export var mobileMenu = "Nav-module--mobileMenu--LQ7tD";
export var mobileNav = "Nav-module--mobileNav--1NeJy";
export var tools = "Nav-module--tools--gU-g1";